import * as $ from "jquery";
import { ConsentHelper } from '../../common/ConsentHubV2';
import Environment from "../../common/environment";
import imkt from '../../imkt';
import 'jquery-validation';
import '@types/jquery.validation';

type RulesType = {
  [key: string]: {
    required: boolean;
    email: boolean;
  }
};

type MessagesType = {
  [key: string]: {
    required: string;
    email: string;
  }
};

export default class ExactTargetFormV2 {
  domRoot: JQuery<HTMLElement>;
  params: {
    consentYes: any;
    isEAP: any;
    useGdpr: boolean;
    subscriptionKey: any;
    useSubmissionBlock: string;
    postSubmissionBlockId: any;
    requiredError: string;
    invalidEmailError: string;
    redirectUrl: any;
    submitError: string;
    exactTargetId: any;
    name: string;
    useSocs: boolean;
  };
  form: JQuery<HTMLElement>;
  emailInput: JQuery<HTMLElement>;
  message: JQuery<HTMLElement>;
  honeypot: JQuery<HTMLElement>;
  useSocs: boolean;
  consentHubPromise?: Promise<any>;
  consentYes: any;
  useConsentHub: any;
  useSubmissionBlock: boolean;
  postSubmissionBlock: any;

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = $(domRoot);
    this.params = { ...params };

    //Component elements
    this.form = $('.exact-target-form', this.domRoot);
    this.emailInput = $('.exact-target-form__email-input input', this.domRoot);
    this.message = $('.exact-target-form__message', this.domRoot);
    this.honeypot = $('.exact-target-form__hp-field input', this.domRoot);
    this.useSocs = params.useSocs;
    this.consentYes = this.params.consentYes;
    this.useConsentHub = this.consentYes.match('generalMarketingOptIn|allowPartnerShare') || this.params.isEAP || (this.params.useGdpr && this.params.subscriptionKey.trim() !== '');
    this.useSubmissionBlock = this.params.useSubmissionBlock === 'true';
    this.postSubmissionBlock = this.useSubmissionBlock && document.querySelectorAll(`#${this.params.postSubmissionBlockId}, .${this.params.postSubmissionBlockId}`);

    if (this.useConsentHub) {
      this.init();
    } else {
      this.bindFormValidation();
    }
  }

  init() {
    this.consentHubPromise = (new ConsentHelper(this.params, this.form)).configPromise;
    this.bindFormValidation();
  }

  bindFormValidation() {

    // Bind validation rules to our form using jQuery Validate functions
    $.validator.methods.email = function( value, element ) {
      return this.optional( element ) || /.+\@.+\..+/.test( value );
    }

    const rules: RulesType = {};
    const messages: MessagesType = {};
    rules[this.params.name] = {
      required: true,
      email: true
    };
    messages[this.params.name] = {
      required: this.params.requiredError,
      email: this.params.invalidEmailError
    };
    this.form.validate({
      rules: rules,
      messages: messages,
      submitHandler: () => {
        if (this.honeypot.val() === "") {
          if (this.useConsentHub) {
            this.consentHubPromise.then((consentHub: ConsentHelper) => {
              consentHub.submitForm(this.submitSuccess.bind(this), this.submitError.bind(this));
            }).catch((error: unknown) => {
              console.error(error);
              this.submitError();
            });
          } else {
            this.submitDirectlyToExactTarget();
          }
        }
      }
    });
  }

  submitSuccess() {
    this.setSocsCookie();
    if (this.useSubmissionBlock) {
      // hide Form
      this.form.css('display', 'none');
      // show post submission content block
      if (this.postSubmissionBlock) {
        const postSubmissionBlocks = Array.from(document.querySelectorAll(`#${this.params.postSubmissionBlockId}, .${this.params.postSubmissionBlockId}`));
        postSubmissionBlocks.forEach(psb => {
          (psb as HTMLElement).style.display = 'block';
        })
      }
    } else {
      this.params.redirectUrl ? this.redirect() : this.showMessage();
    }
  }

  submitError() {
    if ($('.error--server', this.domRoot).length === 0) {
      this.form.after('<div class="error error--server">' + this.params.submitError + '</div>');
    }
  }

  setSocsCookie() {
    if (this.useSocs) {
      imkt.utils?.storage.setCookie("atl_soc2_nda_signed", 1, false, "Strict", "atlassian.com");
    }
  }

  submitDirectlyToExactTarget() {
    const self = this;
    const emailAddress = this.emailInput.val();
    const endpointDomain = Environment.isProduction() ? 'www' : 'wac.stg.internal';
    const postUrl = `https://${endpointDomain}.atlassian.com/apis/exact-target/${emailAddress}/subscribe?mailingListId=${this.params.exactTargetId}`;
    $.ajax({
      url: postUrl,
      method: "POST",
      dataType: "text",
      complete(jqXHR, textStatus) {
        if (textStatus === 'success') {
          self.setSocsCookie();
          self.params.redirectUrl ? self.redirect() : self.showMessage();
        } else {
          // did not submit successfully, if there is not an error then show one
          if ($('.error--server', self.domRoot).length === 0) {
            self.form.append('<div class="error error--server">' + self.params.submitError + '</div>');
          }
        }
      }
    });
  }

  redirect() {
    window.location.href = this.params.redirectUrl;
  }

  showMessage() {
    this.form.hide();
    this.message.removeClass('hide-all');

    // TODO: Is this behavior in use, can this be removed or scoped to a type?
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (typeof dataLayer !== "undefined") {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      dataLayer.push({ 'event': 'emailSubmissionSuccess' });
    }
  }
}
